// Welle M1b Teil B: "Kontakte verwalten" im Mail-Bereich (web: Eintrag in der
// Ordnerspalte, mobil: Icon im Kopf). Liste mit Avatar, Name, Rolle, Stern
// (umschaltbar); Tippen öffnet das Bearbeiten-Sheet (KontaktSheet).
import React, { useEffect, useState } from 'react';
import { MIcon } from '../../lib/micon';
import { apiGet, apiPut, zeigeApiFehler } from '../../lib/api';
import { toast } from '../../lib/toast';
import { Kontakt, initialenVon, rollenLabel } from './MailAbsender';

export function KontakteVerwaltung({ gmailVerbunden, neuLaden, onBearbeiten, onGeaendert, onSchliessen }: {
  gmailVerbunden: boolean;
  /** Zähler: bei Änderung neu laden (nach Speichern/Löschen im Sheet). */
  neuLaden: number;
  onBearbeiten: (k: Kontakt) => void;
  /** Stern geändert → Mail-Liste aktualisieren. */
  onGeaendert: () => void;
  onSchliessen: () => void;
}) {
  const [kontakte, setKontakte] = useState<Kontakt[] | null>(null);

  async function laden() {
    try {
      const d = await apiGet<{ kontakte: Kontakt[] }>('/api/kontakte');
      setKontakte(d.kontakte);
    } catch (e) { zeigeApiFehler(e, 'Kontakte laden fehlgeschlagen'); setKontakte([]); }
  }
  useEffect(() => { laden(); }, [neuLaden]); // eslint-disable-line react-hooks/exhaustive-deps

  async function sternUmschalten(k: Kontakt) {
    const an = k.prio !== 1;
    setKontakte(prev => prev?.map(x => x.id === k.id ? { ...x, prio: an ? 1 : 0 } : x) ?? prev);
    try {
      await apiPut(`/api/kontakte/${k.id}`, { prio: an });
      toast(an ? 'Kontakt wird als Priorität behandelt' : 'Prio-Stern entfernt', 'success');
      onGeaendert();
    } catch (e) { zeigeApiFehler(e, 'Stern ändern fehlgeschlagen'); laden(); }
  }

  return (
    <div className="ld-mkon">
      <div className="ld-mkon__kopf">
        <MIcon name="contact_page" size={18} color="var(--ld-primary)" />
        <span className="ld-mkon__titel">Meine Kontakte</span>
        {kontakte && kontakte.length > 0 && <span className="ld-mkon__anzahl">{kontakte.length}</span>}
        <button className="ld-mkon__zurueck" onClick={onSchliessen}><MIcon name="arrow_back" size={16} />Zu den Mails</button>
      </div>
      {!gmailVerbunden && (
        <div className="ld-mabs-info"><MIcon name="info" size={16} />Die Erkennung wirkt bei Mails aus deinem verbundenen Gmail-Postfach.</div>
      )}
      <div className="ld-mkon__liste">
        {kontakte === null && <div className="ld-mkon__laden">Kontakte werden geladen …</div>}
        {kontakte && kontakte.length === 0 && (
          <div className="ld-empty">
            <MIcon name="contact_page" className="ld-empty-icon" size={36} />
            <p className="ld-empty-title">Noch keine Kontakte</p>
            <p className="ld-empty-subtitle">Öffne eine Mail und tippe auf „Absender speichern“.</p>
          </div>
        )}
        {kontakte?.map(k => {
          const rolle = rollenLabel(k.rolle);
          return (
            <div key={k.id} className="ld-mkon__zeile">
              <button className="ld-mkon__haupt" onClick={() => onBearbeiten(k)} aria-label={`${k.name || k.email} bearbeiten`}>
                <div className="ld-mabs-avatar ld-mabs-avatar--kontakt" aria-hidden="true">{initialenVon(k.name || k.email)}</div>
                <span className="ld-mkon__text">
                  <span className="ld-mkon__name">{k.name || k.email}</span>
                  <span className="ld-mkon__sub">{[rolle, k.name ? k.email : null].filter(Boolean).join(' · ')}</span>
                </span>
              </button>
              <button className={`ld-mabs-sternschalter${k.prio === 1 ? ' ld-mabs-sternschalter--an' : ''}`}
                onClick={() => sternUmschalten(k)} aria-pressed={k.prio === 1}
                aria-label={k.prio === 1 ? `Prio-Stern für ${k.name || k.email} ausschalten` : `Prio-Stern für ${k.name || k.email} einschalten`}
                title={k.prio === 1 ? 'Nicht mehr als Priorität behandeln' : 'Immer als Priorität behandeln'}>
                <MIcon name="star" size={18} fill={k.prio === 1} />
              </button>
            </div>
          );
        })}
      </div>
      <p className="ld-mabs-hinweis ld-mkon__fuss"><MIcon name="lock" size={13} />Kontakte sind nur für dich sichtbar und Teil deines Datenexports.</p>
    </div>
  );
}
